<template>
  <div id="footer">
    <div class="linkArea">
      <!-- <a @click="toAnn()">系統公告</a>
      <span> | </span>
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSc6XmH4iASFnRzKcHWqQOCdshSvLb8PJoD_1xKN12zADWqdMw/viewform" target="_blank" rel="noopener">系統回饋</a>
      <span> | </span>
      <a href="https://community.kingnetsmart.com.tw/CHK/manual/智生活操作手冊-全.pdf" target="_blank" rel="noopener">智生活教學手冊</a>
      <span> | </span>
      <a href="https://www.kingnet.net.tw/" target="_blank" rel="noopener">今網寬頻官網</a>
      <span> | </span>
      <a href="https://www.kingnetsmart.com.tw/tw/" target="_blank" rel="noopener">智生活官網</a> -->
      <p class="edition">
        版本號：{{ version }}
      </p>
    </div>
    <!-- <div class="phone">
      <span>客服專線 412-8166</span><span class="tip"> (手機請加區碼)</span>
    </div> -->
    <div class="copyRight">
      今網智慧科技股份有限公司版權所有 &copy; 2016 Kingnet Corp. All Rights Reserved. Design by Kingnet.
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      version: `${process.env.VUE_APP_VERSION}.${process.env.VUE_APP_VERSION_DATE}`// 版號
    }
  },
  mounted () {

  },
  methods: {
    toAnn () {
      window.location.href = `${window.location.origin}/community/systemUpdates.aspx`
    }
  }
}
</script>

<style lang="sass" scoped>
#footer
  min-width: 1140px
  text-align: center
  padding: 15px 35px
  box-sizing: border-box
  .linkArea
    position: relative
    color: $mainColor
    margin: 0 0 10px
    a
      color: $mainColorDark
      cursor: pointer
    .edition
      position: absolute
      top: 0
      right: 0
      color: $subFontColor
      display: inline-block
      font-size: map-get($fontSize,x-small)
  .phone
    font-size: map-get($fontSize,xx-large)
    font-weight: bold
    color: $mainFontColor
    margin: 0 0 10px
    span
      vertical-align: middle
    .tip
      font-size: map-get($fontSize,small)
      font-weight: normal
  .copyRight
    font-size: map-get($fontSize,x-small)
    color: $subFontColor
    margin: 0 0 10px
</style>
